import { render, staticRenderFns } from "./ApiSmsPackage.vue?vue&type=template&id=58340644&scoped=true"
import script from "./ApiSmsPackage.vue?vue&type=script&lang=js"
export * from "./ApiSmsPackage.vue?vue&type=script&lang=js"
import style0 from "./ApiSmsPackage.vue?vue&type=style&index=0&id=58340644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58340644",
  null
  
)

export default component.exports